import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=6642fede&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6642fede')) {
      api.createRecord('6642fede', component.options)
    } else {
      api.reload('6642fede', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=6642fede&", function () {
      api.rerender('6642fede', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2g0LlPeIvmngg/JS/pricehelp.vue"
export default component.exports